export default __webpack_public_path__ + "static/media/neutrogenaHydroBoost.e85a364b.jpg";